import styled from 'styled-components';

const Wrapper = styled.section`
  p {
    line-height: 2;
    color: var(--clr-grey-5);
  }

  .article{
    padding-top: 70px;
  }
`;

export default Wrapper;
